export enum AuthTypes {
    SIGNIN = '@auth/SIGNIN',
    REQUEST_SIGNIN_EMAIL_PASSWORD = '@auth/REQUEST_SIGNIN_EMAIL_PASSWORD',
    SIGNOUT = '@auth/SIGNOUT',
    REQUEST_SIGNOUT = '@auth/REQUEST_SIGNOUT',
    RESET_PASSWORD = '@auth/RESET_PASSWORD',
    REQUEST_RESET_PASSWORD = '@auth/REQUEST_RESET_PASSWORD',
    RESET_PASSWORD_ERROR = '@auth/RESET_PASSWORD_ERROR',
    CLEAR_RESET_PASSWORD = '@auth/CLEAR_RESET_PASSWORD',
    AUTH_ERROR = '@auth/AUTH_ERROR',
}

export type User = {
    uid: string;
    firstName: string;
    lastName: string;
    email: string;
    roles: string[];
    contactTypes?: string[];
};

export type AuthState = {
    isLogged: boolean;
    isLoading: boolean;
    email: string;
    currentUser: User | undefined;
    error?: string;
    restartSent: boolean;
    restartError?: string;
};

export type AuthAction<Payload> = {
    type: AuthTypes;
    payload: Payload;
};

export type AuthReducer = (state: AuthState, actions: AuthAction<AuthState>) => AuthState;

export interface AuthSignInInput {
    email: string;
    password: string;
}

export interface AuthResetInput {
    email: string;
}
